export function formatearMoneda(monto) {
  const numero = Math.round(Number(monto) || 0); // redondear al entero más cercano
  // Usar locale 'es-AR' para que el separador de miles sea punto
  return `${numero.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
}
